<template>
  <div style="padding:3px">
    <div class="mediaCenter">
      <footer-title>媒体中心</footer-title>

      <ul class="news">
        <li class="clearfix" v-for="item in mediaCenterList" :key="item.title">
          <div class="imgs" @click="goDetail(item.articleUrl)">
            <img :src="item.imageUrl">
          </div>
          <div class="title">
            <h2>{{item.title.trim().length>50?item.title.trim().substr(0,50)+'...':item.title.trim()}}</h2>
            <p>{{item.articleSummary.trim().length>156?item.articleSummary.trim().substr(0,156)+'...':item.articleSummary.trim()}}[<span @click="goDetail(item)">详情</span>]</p>
            <p>{{new Date(item.issueTime).Format("yyyy-MM-dd")}}</p>
          </div>
        </li>
        <li class="loadingText" v-if="!moreShow && mediaCenterList.length " @click="onBlackMore">查看更多</li>
        <li class="loadingText" v-else>没有更多数据...</li>

      </ul>
    </div>

  </div>
</template>

<script>
import footerTitle from "_c/footerTitle.vue";
export default {
  components: { footerTitle },
  data() {
    return {
      mediaCenterList: [],
      page: 1,
      moreShow: false,
    };
  },

  mounted() {
    this.getMedia();
  },
  methods: {
    goDetail(item) {
      if (item.articleSource === "REPRINT") {
        window.open(item.articleUrl);
      } else {
        const { href } = this.$router.resolve({
          path: "/media-article-info",
          query: {
            articleId: item.articleId,
          },
        });
        window.open(href, "_blank");
      }
    },
    onBlackMore() {
      this.page = ++this.page;
      this.getMedia();
    },
    async getMedia() {
      let data = {
        url: "MID-CLIENT-MALL/messageService/websiteService/queryWebsiteArticles",
        body: {
          param: {
            articleType: "media",
            articleStatus: "ON",
            pageNum: this.page,
            pageSize: 5,
          },
        },
      };
      await this.invoke(data).then((res) => {
        if (!res.length) {
          this.moreShow = true;
        } else {
          this.mediaCenterList.push(...res);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mediaCenter {
  margin-top: 20px;
  width: 100%;
  background: #f6f5f5;
  box-shadow: 0px 0px 6px 1px #ccc;
  padding: 20px 20px 100px 20px;
  .news {
    li {
      margin-top: 10px;
      .imgs {
        width: 350px;
        height: 260px;
        float: left;
        cursor: pointer;
        img {
          width: 350px;
          height: 230px;
        }
      }
      .title {
        width: 660px;
        float: left;
        margin-left: 20px;
        h2 {
          color: #ff8000;
        }
        p:first-of-type {
          margin-top: 20px;
          span {
            color: #ff8000;
            cursor: pointer;
          }
        }
        p {
          color: #838181;
          font-size: 16px;
        }
        p:last-of-type {
          margin-top: 10px;
        }
      }
    }
    .loadingText {
      text-align: center;
      color: #ff8000;
      padding: 10px;
      cursor: pointer;
    }
  }
}
</style>